// extracted by mini-css-extract-plugin
module.exports = {"subheading":"jargon-buster_subheading__X_F7z","jargonList":"jargon-buster_jargonList__5ra9x","container":"jargon-buster_container__Feb63"};